import React from 'react';

const Cross = () => {
    return (React.createElement("svg", { width: "11", height: "11", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.2591 1.7735L9.31911 0.833496L5.59245 4.56016L1.86578 0.833496L0.925781 1.7735L4.65245 5.50016L0.925781 9.22683L1.86578 10.1668L5.59245 6.44016L9.31911 10.1668L10.2591 9.22683L6.53245 5.50016L10.2591 1.7735Z", fill: "currentColor" })));
};

export { Cross as default };
